import script from "./OrientationLock.vue?vue&type=script&setup=true&lang=js"
export * from "./OrientationLock.vue?vue&type=script&setup=true&lang=js"

import "./OrientationLock.vue?vue&type=style&index=0&id=efb13300&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efb13300"]])

export default __exports__